import React, { createContext, useEffect, useState } from 'react'
import { translations } from './translations'

export const MyContext = createContext()

const MyState = ({ children }) => {
    const [darkMode, setDarkMode] = useState(true)
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('language') || 'en'
    })

    const t = (key) => {
        return translations[language]?.[key] || translations['en']?.[key] || key
    }

    useEffect(() => {
        if (darkMode) {
            document.documentElement.setAttribute('data-theme', 'dark')
            document.documentElement.setAttribute('data-bs-theme', 'dark')
        } else {
            document.documentElement.setAttribute('data-theme', 'light')
            document.documentElement.setAttribute('data-bs-theme', 'light')
        }
    }, [darkMode])

    useEffect(() => {
        localStorage.setItem('language', language)

        let link = document.getElementById('bootstrap-css')
        if (!link) {
            link = document.createElement('link')
            link.id = 'bootstrap-css'
            link.rel = 'stylesheet'
            document.head.appendChild(link)
        }

        if (language === 'ar') {
            link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.rtl.min.css'
            document.documentElement.setAttribute('dir', 'rtl')
            document.documentElement.setAttribute('lang', 'ar')
        } else {
            link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css'
            document.documentElement.removeAttribute('dir')
            document.documentElement.setAttribute('lang', 'en')
        }
    }, [language])

    return (
        <MyContext.Provider value={{ darkMode, setDarkMode, language, setLanguage, t }}>
            {children}
        </MyContext.Provider>
    )
}

export default MyState

